(() => {
  function updateCount(count) {
    if (!Number.isInteger(count)) return;
    const roots = [document];
    for (let i = 0; i < roots.length; i++) {
      roots[i].querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
      roots[i].querySelectorAll('instant-layout').forEach(el => { if (el.shadowRoot) roots.push(el.shadowRoot); });
    }
  }
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, event => updateCount(event.cartData?.item_count));
  function findAnchor(id) {
    const roots = [document];
    for (let i = 0; i < roots.length; i++) {
      const target = roots[i].getElementById(id);
      if (target) return target;
      roots[i].querySelectorAll('instant-layout').forEach(el => { if (el.shadowRoot) roots.push(el.shadowRoot); });
    }
  }
  function scrollToHash() {
    if (!location.hash) return;
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    findAnchor(id)?.scrollIntoView({block: 'start'});
  }
  document.addEventListener('click', event => {
    const anchor = event.composedPath().find(el => el instanceof HTMLAnchorElement && el.hash);
    if (!anchor || anchor.origin !== location.origin || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation();
    if (anchor.pathname !== location.pathname || anchor.search !== location.search) {
      location.assign(anchor.href);
      return;
    }
    history.pushState(null, '', anchor.href);
    scrollToHash();
    const root = anchor.getRootNode();
    const close = root.querySelector('[data-overlay="mobile-menu"][data-state="open"] button[data-overlay-close]');
    if (close) close.click();
  }, true);
  window.addEventListener('hashchange', scrollToHash);
  window.addEventListener('load', scrollToHash, {once: true});
})();

(() => {
  function sync(form) {
    if (!form) return;
    const qty = Number(form.querySelector('[name="quantity"]')?.value);
    if (!Number.isInteger(qty) || qty < 1) return;
    form.querySelectorAll('[data-cw-bundle-qty]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.cwBundleQty) === qty)));
    const summary = form.querySelector('[data-cw-bundle-summary]');
    if (summary) {
      const cents = qty * 2995 - (qty >= 3 ? 2990 : qty >= 2 ? 995 : 0);
      summary.textContent = qty + (qty === 1 ? ' bag' : ' bags') + ' · A$' + (cents / 100).toFixed(2) + ' total';
    }
  }
  document.addEventListener('click', event => {
    const button = event.composedPath().find(el => el instanceof HTMLElement && el.hasAttribute('data-cw-bundle-qty'));
    if (!button) return;
    const form = button.closest('form');
    const input = form?.querySelector('[name="quantity"]');
    if (!input) return;
    input.value = button.dataset.cwBundleQty;
    input.dispatchEvent(new Event('input', {bubbles: true, composed: true}));
    input.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
    sync(form);
  }, true);
  function onQuantity(event) {
    const input = event.composedPath().find(el => el instanceof HTMLInputElement && el.name === 'quantity');
    if (input) sync(input.closest('form'));
  }
  document.addEventListener('input', onQuantity, true);
  document.addEventListener('change', onQuantity, true);
})();
